<template lang="pug">
.selected-product(:class="{[clazz]: !!clazz}")
  .empty-selected-wrap(v-if="!selectedProduct")
    p.text-center.xs-f-small.md-f-medium.lg-f-small.max-at-tweak
      | Click on any
      br
      | swatch above to
      br
      | compare.

  .xs-12(v-if="selectedProduct")
    .image-wrap
      img(:src="squareSwatch.url" :alt="squareSwatch.alt_text")
      .x-wrap.xs-f-large-md-f-xlarge.lg-f-large.max-at-tweak(@click="$emit('selected')")
        span.icon-x.color-white(data-mr-ass="remove-first-shade")
          span.ada-tooltip x icon
      .pick-wrapper.xs-f-xxsmall.md-f-xsmall.lg-f-xxsmall.max-at-tweak(v-if="isBestOrOtherMatch" :class="{ best: isBestMatch}")
        .pick
        p.pick-text.header.semi-bold(v-if="isBestMatch") best match
        p.pick-text.two.header.semi-bold(v-if="isOtherMatch") match

      .not-recommended-wrap.bg-black-a50.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak(v-if="selectedProduct.notRecommended")
        .text-center.full-width
          a.color-white.underline.xs-f-xsmall.md-f-small.lg-f-xsmall(@click="$emit('notRecommended')") Not recommended
            span.icon-question
              span.ada-tooltip question icon
    a.mr-btn.btn-block.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak(:href="`/product/${selectedProduct.urlKey}`") see details
    a.prod-name.upper.semi-bold.color-font.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak(:href="`/product/${selectedProduct.urlKey}`", data-mr-ass="product-name-first") {{selectedProduct.name}}&nbsp;
    p.prod-desc.xs-f-small.md-f-medium.lg-f-small.max-at-tweak {{selectedProduct.desc}}

</template>
<script>
  export default {
    name: 'SelectedProduct',

    emits: ['selected', 'notRecommended'],
    inject: ['getObjProperty'],
    props: {
      selectedProduct: { type: Object, default: () => ({}) },
      clazz: { type: String, default: () => '' },
      isBestMatch: {
        type: Boolean,
        default: () => false,
      },
      isOtherMatch: {
        type: Boolean,
        default: () => false,
      },
    },
    computed: {
      squareSwatch() {
        return this.getObjProperty(this, 'selectedProduct.imagery.squareSwatch') || {};
      },
      isBestOrOtherMatch() {
        return this.isBestMatch || this.isOtherMatch;
      },
    },
  };
</script>